<template>
    <div class="my-charts">
        <div class="child-chart-container" :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";
import chartResizeMixin from "./chartResizeMixin";

export default {
    name: "secondDataSequenceEchart",
    mixins: [chartResizeMixin],
    props: {
        id:{
            type: String,
            default:"secondDataSequenceEchart"
        },
        title:{
            type: String,
            default:"时序图"
        },
        name:{
            type: String,
            default:""
        },
        echartData:{
            type: Array,
            default: []
        },
        sequenceEchartData:{
            type: Array,
            default: []
        }
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
        echartData(newValue,oldValue){
            this.echartList = newValue;
            this.init()
        },
        sequenceEchartData(newValue,oldValue){
            this.sequenceEchartList = newValue;
            this.init()
        }
    },
    data() {
        return {
            sequenceChart: null,
            echartList:[],
            sequenceEchartList:[],
            chartOption:{
                tooltip: {
                    formatter: function(t) {
                        var e = t.marker + t.name + "<br/>";
                        e += "时间区间：第" + t.value[1].toFixed(2) + "分钟 - 第" + t.value[2].toFixed(2) + "分钟<br/>";
                          e += "持续时长：" + t.value[3].toFixed(2) + " 分钟<br/>";
                        for (var a = [], i = 0; i < t.value[4].length; i += 25){
                            a.push(t.value[4].slice(i, i + 25));
                        }
                        return e += "内容：<br/>" + a.join("<br/>")
                    }
                },
                title: {
                    text: '',
                    left: 'center'
                },
                grid:{
                    left:'15%',
                    right:'5%',
                    bottom:'7%'
                },
                xAxis: {
                    scale: false,
                    axisLine: { show: true },
                    axisLabel: {
                        formatter: function (val) {
                            return val + '分钟';
                        }
                    },
                },
                yAxis: {
                    data: []
                },
                series: [
                    {
                        type: 'custom',
                        renderItem: function(t, e) {
                            var a = e.value(0)
                              , i = e.coord([e.value(1), a])
                              , s = e.coord([e.value(2), a])[0] - i[0]
                              , r = Math.max(1, .1 * e.size([0, 1])[1])
                              , n = echarts.graphic.clipRectByRect({
                                x: i[0],
                                y: i[1] - r / 2,
                                width: s,
                                height: r
                            }, {
                                x: t.coordSys.x,
                                y: t.coordSys.y,
                                width: t.coordSys.width,
                                height: t.coordSys.height
                            });
                            return n && {
                                type: "rect",
                                transition: ["shape"],
                                shape: n,
                                style: e.style()
                            }
                        },
                        itemStyle: {
                            opacity: 0.8
                        },
                        encode: {
                            x: [1, 2],
                            y: 0
                        },
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            this.echartList = this.echartData;
            this.sequenceEchartList = this.sequenceEchartData;
            const categoryList = [this.name];
            const chartDataList = [];
            // 开始时间  结束时间  时间区间  内容
            if (this.sequenceEchartList&&this.sequenceEchartList.length>0){
                this.sequenceEchartList.forEach((item,index )=> {
                    var lv = item.时间区间;
                    var text = item.相关文本;
                    chartDataList.push({
                        name: this.name,
                        value: [index, lv[0], lv[1], lv[1]-lv[0],text],
                        itemStyle: {
                            normal: {
                                color: "#c23531"
                            }
                        }
                    })
                })
            }
            this.chartOption.yAxis.data = categoryList;
            this.chartOption.series[0].data = chartDataList;
            this.chartOption.title.text = this.name+'时序图'
            this.sequenceChart = echarts.init(document.getElementById(this.id));
            this.sequenceChart.setOption(this.chartOption);
            this.sequenceChart.on('click', (params) => {
                // 根据需要处理点击事件，例如显示提示框、跳转等
                let currentTime = params.value[1].toFixed(1);
                let timeSecond = Math.floor(60 * currentTime)
                this.$emit('skip-video',timeSecond);
            });
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    color: #333!important;
    display: flex;
    height: auto;
}
.child-chart-container{
    width: 100%;
    max-width: 460px;
    height: 380px;
    margin: auto;
}
</style>